<template>
  <div class="report">
    <mu-container>
      <!-- <mu-row>
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item v-model="budgetForm.center_id" :options="centers" />
          <van-dropdown-item v-model="budgetForm.budget_year" :options="months" />
        </van-dropdown-menu>
      </mu-row> -->
      <mu-row gutter>
        <mu-col span="7" lg="7" sm="7">
          <mu-select
            label="请选择成本中心"
            v-model="budgetForm.center_id"
            chips
            full-width
            multiple
            @change="getReportDetail()"
          >
            <mu-option
              label="全部机构"
              :value="0"
            ></mu-option>
            <mu-option
              v-for="item in centers"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-col>
        <mu-col span="5" lg="5" sm="5">
          <mu-select
            label="请选择预算年月"
            v-model="budgetForm.budget_year"
            full-width
            @change="getReportDetail()"
          >
            <mu-option
              v-for="item in months"
              :key="item"
              :label="item"
              :value="item"
            ></mu-option>
          </mu-select>
        </mu-col>
      </mu-row>
    </mu-container>
    <mu-container>
      <mu-row>
        <div style="text-align: left; font-weight: bold;line-height:30px;font-size:14px;">
          当月预计收款：{{ target_income.toLocaleString()
          }}<br />当月实际收款：{{ collected.toLocaleString() }}
          <br />当月费用：{{ cost.toLocaleString()}}<br />
          <span>注：以上数据每日凌晨更新。</span>
        </div>
      </mu-row>
      <mu-row>
        <!-- <mu-paper :z-depth="1">
          <mu-data-table
            :columns="columns"
            :sort.sync="sort"
            @sort-change="handleSortChange"
            :data="budgets"
            stripe
            class='report_table'
          >
            <template slot-scope="scope">
              <td>{{ scope.row.cost_account.title }}</td>
              <td class="is_right">{{ scope.row.budget_year }}</td>
              <td class="is_right">{{ scope.row.budget }}元</td>
              <td class="is_right">{{ scope.row.budget_used }}元</td>
              <td class="is_right">{{ scope.row.budget_applying }}元</td>
            </template>
          </mu-data-table>
        </mu-paper> -->
        <el-table
          :data="budgets"
          v-loading="loading"
          border
          show-summary
          stripe
          style="width: 100%;text-align:center;"
          class="budget_list"
          :summary-method="getSummaries"
          height="600"
        >
          <el-table-column prop="cost_account.title" label="费用科目">
            <template slot-scope="scope">
              <span
                @click="lookup(scope.row)"
                type="text"
                style="color: #3f51b5"
                >{{ scope.row.cost_account.title }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="budget_year" label="预算年月">
          </el-table-column> -->
          <el-table-column prop="budget" sortable label="预算">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.budget).toLocaleString()}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="budget_used" sortable label="已用">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.budget_used).toLocaleString()}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="budget_applying" sortable label="申请中">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.budget_applying).toLocaleString()}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="budget_use" sortable label="费用总计">
            <template slot-scope="scope">
              <span>{{
                 parseInt(
                  scope.row.budget_used + scope.row.budget_applying
                ).toLocaleString()
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="percent" sortable label="占收款比例">
            <template slot-scope="scope">
              <span>{{
                (
                  ((scope.row.budget_used + scope.row.budget_applying) /
                    collected) *
                  100
                ).toFixed(2) + "%"
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="budget_rest" sortable label="剩余">
            <template slot-scope="scope">
              <span>{{ scope.row.budget_rest.toLocaleString()}}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </mu-row>
    </mu-container>

    <Footer active="Report"></Footer>
    <van-popup
      v-model="budgetDetail.show"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <mu-appbar color="indigo500" title="费用使用列表" class="budget_title">
        <mu-button slot="right" icon @click="budgetDetail.show = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
      </mu-appbar>
      <!-- <div class="select_top" v-if="budgetDetail.budget.cost_center">
        {{budgetDetail.budget.cost_center.title}} - {{budgetDetail.budget.cost_account.title}}（{{budgetDetail.budget.budget_year}}）
      </div> -->
      <el-table
          :data="budgetDetail.flows"
          border
          show-summary
          stripe
          style="width: 96%;margin-bottom:30px;"
          class="budget_detail"
          :summary-method="getSummaries"
          
        >
          <el-table-column prop="flow.title" label="审批标题">
          </el-table-column>
          <el-table-column prop="flow.name" label="申请人">
          </el-table-column>
          <el-table-column prop="amount" sortable class="amount" label="金额">
            <template slot-scope="scope">
              <span>{{ scope.row.amount.toLocaleString()}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="flow.status" label="状态">
            <template slot-scope="scope">
               <mu-button color="success" small v-if="scope.row.flow.status==1">已通过</mu-button>
               <mu-button color="indigo500" small v-if="scope.row.flow.status==0">审核中</mu-button>
              <!-- <span
                @click="lookup(scope.row)"
                type="text"
                style="color: #3f51b5"
                >{{ scope.row.cost_account.title }}</span
              > -->
            </template>
          </el-table-column>
        </el-table>
    </van-popup>
    <!-- <mu-dialog
      width="360"
      transition="slide-bottom"
      fullscreen
      scrollable
      lock-scroll
      :open.sync="budgetDetail.show"
    >
      <mu-appbar color="indigo500" title="费用使用列表">
        <mu-button slot="right" icon @click="budgetDetail.show = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
      </mu-appbar>
      <div class="select_top" v-if="budgetDetail.budget.cost_center">
        {{budgetDetail.budget.cost_center.title}} - {{budgetDetail.budget.cost_account.title}}（{{budgetDetail.budget.budget_year}}）
      </div>
      <el-table
          :data="budgetDetail.flows"
          border
          show-summary
          stripe
          style="width: 100%"
          
        >
          <el-table-column prop="flow.title" label="审批标题">
          </el-table-column>
          <el-table-column prop="flow.name" label="申请人">
          </el-table-column>
          <el-table-column prop="amount" sortable label="金额">
          </el-table-column>
          <el-table-column prop="flow.status" label="状态">
          </el-table-column>
        </el-table>

    </mu-dialog> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      centers: [],
      months: [],
      budgetForm: {
        center_id: [0],
        budget_year: '',
        account_id:'',
      },

      columns: [
        { title: "费用科目", name: "title" },
        // { title: "预算年月", name: "budget_year", align: "center" },
        { title: "预算金额", name: "budget", align: "center", sortable: true },
        {
          title: "已用预算（元）",
          name: "budget_used",
          align: "center",

          sortable: true,
        },
        {
          title: "申请中预算（元）",
          name: "budget_applying",
          align: "center",

          sortable: true,
        },
      ],
      order: "asc",
      budgets: [],
      target_income: "",
      collected: "",
      cost:'',
      budgetDetail: {
        flows: [],
        budget:{},
        show: false,
      },
      loading:true,
    };
  },
  created() {
    document.title = "报表中心";
    this.getList();
  },
  methods: {
    getList() {
      this.$http.get("report_list").then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          }).then(() => {
            this.$router.push({'name':'Index'})
          });
        }
        this.centers = res.data.data.list;
        this.months = res.data.data.months;
        // this.budgetForm.center_id = this.centers[0].id;
        this.budgetForm.budget_year = this.months[1];
        this.getReportDetail();
        if(this.budgetForm.center_id){
          
        }
        
      });
    },
    getReportDetail() {
      if(this.budgetForm.center_id.length == 0){
        return false;
      }
      this.loading = true;
      this.budgets = '';
      this.$http.post("report", this.budgetForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          }).then(() => {
            this.$router.push({'name':'Report'})
          });
        }
        this.budgets = res.data.data.budget;
        this.collected = res.data.data.collected;
        this.target_income = res.data.data.target_income;
        this.cost = res.data.data.cost;
        this.loading = false;
      });
    },
    lookup(row) {
      this.budgetDetail.show = true;
      // this.getBudgetDetail(row.id);
      // console.log(row)
      this.budgetForm.account_id = row.cost_account.id;
      this.getFlows()
    },
    getFlows(){
      this.budgetDetail.flows = [];
      this.$http.post('report/flows',this.budgetForm)
      .then((res)=>{
        this.budgetDetail.flows = res.data.data
      })

    },
    getBudgetDetail(id){
      this.$http.get('budget/'+id)
      .then((res)=>{
        this.budgetDetail.flows = res.data.data.flows
        this.budgetDetail.budget = res.data.data.budget

      })

    },
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toLocaleString()
            // sums[index] += ' 元';
          } else {
            // sums[index] = 'N/A';
            sums[index] = '';
          }
        });

        return sums;
      }
  },
};
</script>
<style scoped>
.flow{
  font-size:14px;
}
.mu-row{
  border-collapse:collapse;
}
.mu-col{
  margin:0px -1px -1px 0px;
  border:solid #000 1px;
  padding:4px 10px;
  line-height:20px;
  text-align:left;
}

</style>

<style>
.budget_list .cell{
  text-align:center;
  font-weight:bold;
  padding-left:0px !important;
  padding-right:0px !important;

}
.budget_title{
  position:fixed;
  top:0px;
  left:0px;
  right:0px;
  z-index:9999;

}
.budget_detail{
  margin:75px auto 10px auto;
}
.budget_detail .cell{
  text-align:center;
  font-weight:bold;
  padding-left:0px !important;
  padding-right:0px !important;
}
.report_table {
  width: 100% !important;
}
.report_table .mu-table-header {
  width: 100% !important;
}

.report {
  margin-bottom: 90px;
  padding:5px;
}
.report .amount{
  text-align:center;
  font-weight:bold;
}
.select_top {
  font-weight: bold;
  text-align: center;
  color: #000000;
  margin: 10px auto;
  font-size: 20px;
}
.mu-dialog-fullscreen .mu-dialog-body {
    padding: 0;
    max-height: 1200px !important;
}
</style>


